define(function (require) {
    "use strict";
    return {
        getScript:function (id){
        	var script = "<!-- Google Tag Manager -->" +
				"<noscript><iframe src=\"//www.googletagmanager.com/ns.html?id=" + id + " " +
				"height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe></noscript>" +
				"<script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':" +
				"new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0]," +
				"j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=" +
				"'//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);" +
				"})(window,document,'script','dataLayer','" + id + "');</script>" +
				"<!-- End Google Tag Manager -->";
        	
        	return script;
        }	
    }
});


//////////////////
// WEBPACK FOOTER
// ./js/common/scripts/GoogleTagManager.js
// module id = 1825
// module chunks = 4